import React, { useState } from "react";
import { ControlledMenu, useMenuState } from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";

export default function ContextMenuObject(props) {
    const { toggleMenu, ...menuProps } = useMenuState();
    const [anchorPoint, setAnchorPoint] = useState({ x: 0, y: 0 });

    return (
        <div
            onContextMenu={(e) => {
                e.preventDefault();
                setAnchorPoint({ x: e.clientX, y: e.clientY });
                toggleMenu(true);
            }}
            className={props.className}
        >
            {props.target}
            <ControlledMenu
                {...menuProps}
                anchorPoint={anchorPoint}
                onClose={() => toggleMenu(false)}
            >
                {props.menu}
            </ControlledMenu>
        </div>
    );
}
